import React from 'react';
import DataCenterAndLocationsPage from '../DataCenterAndLocationsPage';
import PageSEO from '../../../../../Components/SEO/PageSEO';

const CaliforniaDataCenterAndLocationsPage = () => {
  // Define structured data for the California Data Center
  const californiaDataCenterSchema = {
    "@context": "https://schema.org",
    "@type": "DataCenter",
    "name": "WebNX Los Angeles Data Center",
    "description": "Enterprise-grade data center in Los Angeles offering high-performance colocation services with direct carrier connections and optimized routing for Asia-Pacific traffic.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Los Angeles",
      "addressRegion": "CA",
      "addressCountry": "US"
    },
    "offers": {
      "@type": "AggregateOffer",
      "offers": [
        {
          "@type": "Offer",
          "name": "Colocation Services",
          "description": "Premium colocation services with redundant power, cooling, and network infrastructure"
        },
        {
          "@type": "Offer",
          "name": "Network Services",
          "description": "High-performance BGP Route Optimized network with direct carrier connections"
        }
      ]
    },
    "featureList": [
      "100,000+ sq. ft. of premium colocation space",
      "N+1 power infrastructure with dual grid utility feeds",
      "Direct carrier connections to major providers",
      "Real-time BGP route optimization",
      "Asia-Pacific traffic optimization",
      "24/7/365 monitoring and support"
    ],
    "additionalProperty": [
      {
        "@type": "PropertyValue",
        "name": "Network Capacity",
        "value": "1Tbps+ total uplink capacity"
      },
      {
        "@type": "PropertyValue",
        "name": "Carrier Connections",
        "value": "Direct connections to 11 major carriers"
      },
      {
        "@type": "PropertyValue",
        "name": "Power Redundancy",
        "value": "N+1 UPS systems with diesel generators"
      }
    ]
  };

  return (
    <>
      <PageSEO
        title="Los Angeles Data Center | High-Performance Colocation Services | WebNX"
        description="Explore WebNX's Los Angeles data center offering premium colocation services with direct carrier connections, optimized Asia-Pacific routing, and enterprise-grade infrastructure. Features include 100,000+ sq. ft. of space, N+1 power systems, and 1Tbps+ network capacity."
        keywords="Los Angeles data center, LA colocation, California data center, Asia-Pacific network optimization, carrier-neutral facility, enterprise colocation, high-performance network, BGP route optimization, carrier connections, redundant power"
        path="/datacenter-locations-and-networks/california"
        image="/images/california-datacenter.jpg"
        schema={californiaDataCenterSchema}
        socialProfiles={{
          facebook: "https://www.facebook.com/webnx",
          linkedin: "https://www.linkedin.com/company/webnx"
        }}
      />
      <DataCenterAndLocationsPage location={"california"} />
    </>
  );
};

export default CaliforniaDataCenterAndLocationsPage;